// import axios from 'axios'
import storage from 'didi-store'
import { EventBus } from '@didi/events'
import { urlParse } from '@/common/utils/util'
import hostsConfig from '@/common/config/hosts'
import { omitBy, isNaN, isUndefined, isNull, isEmpty } from 'lodash-es'
import { getBDLocale, getBDCountry, i18n, getBDTimezone } from '@/common/utils/i18n'
import { errnoData, preloading } from './middlewares'
import { trackEvent } from '@/common/utils/log'
import qs from 'qs'
import { requestTrackStart, requestTrackEnd } from '../../raven'
import { getBizId } from './BizUtils'
import store from '@/store'
import { isAbasteceBiz } from '@/common/utils/BizUtils'
import VueI8n from '@/i18n/locale'
import dajax from '@didi/dajax'
const env = process.env.NODE_ENV
const hosts = hostsConfig.hosts

export const getCommonParams = function () {
  return {
    from_app: 1,
    ticket: urlParse(location.href).ticket || storage.get('ticket') || store.state.login.ticket,
    // ticket: '027f29fec60d00f4c11b2f642f98e03a0002200386000',
    locale: getBDLocale(),
    country: getBDCountry(),
    timezone: getBDTimezone(),
  }
}

/** POST 且声明 JSON body 时，公共参数同时进 body 和 query */
function isJsonBodyPost(config, method) {
  const m = (method || config.method || '').toLowerCase()
  if (m !== 'post') return false
  const headers = config.headers || {}
  const ct = headers['Content-Type'] || headers['content-type'] || ''
  return typeof ct === 'string' && ct.toLowerCase().indexOf('application/json') !== -1
}

function normalizeJsonBodyData(data) {
  if (data == null || data === '') return {}
  if (typeof data === 'string') {
    try {
      const parsed = JSON.parse(data)
      return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : {}
    } catch (e) {
      return {}
    }
  }
  if (typeof data === 'object' && !Array.isArray(data)) return data
  return {}
}

function isNonPlainBody(data) {
  if (data == null) return false
  if (typeof FormData !== 'undefined' && data instanceof FormData) return true
  if (typeof Blob !== 'undefined' && data instanceof Blob) return true
  if (typeof URLSearchParams !== 'undefined' && data instanceof URLSearchParams) return true
  return false
}

function applyMergedParams(config, mergedParams, method) {
  if (isJsonBodyPost(config, method)) {
    // 显式 JSON 请求：公共参数同时放入 query 与 body
    if (isNonPlainBody(config.data)) {
      config.params = mergedParams
      return
    }
    config.params = mergedParams
    const bodyObj = normalizeJsonBodyData(config.data)
    config.data = Object.assign({}, mergedParams, bodyObj)
  } else {
    config.params = mergedParams
  }
}

/**
 * 识别gateway地址，自动转换请求配置
 * 将url替换成/gateway
 * 将api添加到params中
 */
export function transferConfig(url) {
  if (url.indexOf('http') !== -1 || url.indexOf('//:') !== -1) {
    return {
      transUrl: url,
      transParams: {},
    }
  }
  let transParams = {}
  let transUrl = url
  const isGatewayReg = url.indexOf('.') !== -1
  const isCommonGatewayReg = /^common./g
  if (isGatewayReg) {
    if (isCommonGatewayReg.test(url)) {
      transUrl = '/common'
      transParams = {
        api: url,
      }
    } else {
      transUrl = '/gateway'
      transParams = {
        api: url,
      }
    }
  }
  return {
    transUrl,
    transParams,
  }
}

/**
 * 发送 POST 请求，数据放在 body 中。
 * 避免使用历史方法导致 url 超长报错: 414 Request-URI Too Large
 * @param {String} url
 * @param {Object} data
 * @param {Object} config
 * @returns
 */
export function postRequest(url, data, config = { method: 'post' }) {
  Object.assign(config, { data })
  const urlPath = window.location.href || ''
  const {
    transParams: { api },
  } = transferConfig(url)
  config.url = prefixUrl(url)
  if (env === 'development') {
    // 主要为了proxy代理
    config.headers = {
      ...config.headers,
    }
    if (api) config.headers.api = api
  }
  config.reqId = requestTrackStart({
    url: config.url,
    params: config.params,
  })
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    config.needEncrypt = true
    if (api) config.api = api

    const globalParams = await SodaGlobalParams()
    const commonParams = getCommonParams()
    const mergedParams = Object.assign(
      {},
      commonParams,
      {
        ...globalParams,
        ticket: globalParams.ticket || commonParams.ticket,
        bizId: getBizId(),
      },
      config.params || {},
    )
    applyMergedParams(config, mergedParams, 'post')
    console.log('config ------>', config)
    const showToast = true
    const errToastText = isAbasteceBiz()
      ? VueI8n.t('Internal_Tools_App_qYbb_MgvG' /** 系统异常，请稍后重试 */)
      : i18n.gettext('您当前的网络环境不太好')
    dajax(config)
      .then(response => {
        if (response.status !== 200) {
          reject(response)
        }
        return response
      })
      .then(({ data }) => {
        requestTrackEnd({
          reqId: config.reqId,
          traceId: data.traceId || data.trace,
        })
        trackEvent('sailing_gattarman_x_api_traceID', {
          traceID: data.traceId,
          baseUrl: config.url,
          ...config,
          urlPath,
        })
        if (!data || data.errno) {
          if (showToast) EventBus.emit('ajaxErrorToast', data.errmsg || errToastText)
          if (data.data && data.data.redirectUrl) {
            // logout
            if (window.SODA_RN) {
              if (!isUnLogin) {
                window.SodaBD.requestLogout({}, () => {})
              }
              isUnLogin = true
            } else {
              if (!isUnLogin) {
                trackEvent('sailing_gattarman_x_page_entry', {
                  pageName: 'login',
                })
                if (config && config.params && config.params.current) {
                  trackEvent('sailing_gattarman_x_unlogin_to_login_time_sw', {
                    phase: 2,
                    time_diff: +new Date() - config.params.current,
                  })
                }
              }
              isUnLogin = true

              if (config.url.includes('getUserInfo')) {
                storage.set('notLoginToRedirect', +new Date())
              }

              window.setTimeout(() => {
                location.href = data.data.redirectUrl
              }, 10)
            }
          }
          trackEvent('sailing_gattarman_x_api_message_error', {
            ...config,
            traceId: data?.traceId,
            errorType: data && data.errno,
            errorMessage: data && data.errmsg,
          })
          reject(data)
        } else {
          isUnLogin = false
        }
        resolve(data)
      })
      .catch(error => {
        if (showToast) EventBus.emit('ajaxErrorToast', error.errmsg || errToastText + error)
        reject(error)
      })
  })
}

export function prefixUrl(
  url,
  params,
  options = { isFilterEmptyParams: false, isAddCommonParams: false },
) {
  let tmpParams = { ...params }
  if (options.isFilterEmptyParams) {
    // 过滤错误函数
    tmpParams = omitBy(tmpParams, v => isNaN(v) || isUndefined(v) || isNull(v) || v === '')
  }
  if (options.isAddCommonParams) {
    const commonParams = getCommonParams()
    tmpParams = {
      ...commonParams,
      ...tmpParams,
    }
  }
  if (url.indexOf('http') < 0) {
    if (url.indexOf('/') === 0) {
      url = hosts.api + url
    } else {
      // 如果是xxx.xxx.xxx兼容
      const { transUrl, transParams } = transferConfig(url)
      tmpParams = { ...transParams, ...tmpParams }
      url = hosts.gateway + transUrl + '?' + qs.stringify(tmpParams)
      return url
    }
  }
  // 参数处理逻辑
  if (url.indexOf('?') !== -1) {
    return url
  } else if (!isEmpty(tmpParams)) {
    return url + '?' + qs.stringify(tmpParams)
  }
  return url
}
let isUnLogin = false
function setRequest(method, config, options = {}) {
  const urlPath = window.location.href || ''
  const {
    transParams: { api },
  } = transferConfig(typeof config === 'string' ? config : config.url)
  // config 可能是url，也可能是放到config.url里面
  if (typeof config === 'string') {
    config = Object.assign(
      {
        method,
        url: prefixUrl(config),
      },
      arguments[2],
    )
  } else {
    config.url = prefixUrl(config.url)
  }
  if (env === 'development') {
    // 主要为了proxy代理
    config.headers = {
      ...config.headers,
    }
    if (api) config.headers.api = api
  }
  config.reqId = requestTrackStart({
    url: config.url,
    params: config.params,
  })
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    config.method = method
    config.needEncrypt = true
    if (api) config.api = api

    const globalParams = await SodaGlobalParams()
    const commonParams = getCommonParams()
    const mergedParams = Object.assign(
      {},
      commonParams,
      {
        ...globalParams,
        ticket: globalParams.ticket || commonParams.ticket,
        bizId: getBizId(),
      },
      config.params || {},
    )
    applyMergedParams(config, mergedParams, method)
    const { showToast = true } = options || {}
    const errToastText = isAbasteceBiz()
      ? VueI8n.t('Internal_Tools_App_qYbb_MgvG' /** 系统异常，请稍后重试 */)
      : i18n.gettext('您当前的网络环境不太好')
    dajax(config)
      .then(response => {
        if (response.status !== 200) {
          reject(response)
        }
        return response
      })
      .then(({ data }) => {
        requestTrackEnd({
          reqId: config.reqId,
          traceId: data.traceId || data.trace,
        })
        trackEvent('sailing_gattarman_x_api_traceID', {
          traceID: data.traceId,
          baseUrl: config.url,
          ...config,
          urlPath,
        })
        if (!data || data.errno) {
          if (showToast) EventBus.emit('ajaxErrorToast', data.errmsg || errToastText)
          if (data.data && data.data.redirectUrl) {
            // logout
            if (window.SODA_RN) {
              if (!isUnLogin) {
                window.SodaBD.requestLogout({}, () => {})
              }
              isUnLogin = true
            } else {
              if (!isUnLogin) {
                trackEvent('sailing_gattarman_x_page_entry', {
                  pageName: 'login',
                })
                if (config && config.params && config.params.current) {
                  trackEvent('sailing_gattarman_x_unlogin_to_login_time_sw', {
                    phase: 2,
                    time_diff: +new Date() - config.params.current,
                  })
                }
              }
              isUnLogin = true

              if (config.url.includes('getUserInfo')) {
                storage.set('notLoginToRedirect', +new Date())
              }

              window.setTimeout(() => {
                location.href = data.data.redirectUrl
              }, 10)
            }
          }
          trackEvent('sailing_gattarman_x_api_message_error', {
            ...config,
            traceID: data?.traceId,
            errorType: data && data.errno,
            errorMessage: data && data.errmsg,
          })
          reject(data)
        } else {
          isUnLogin = false
        }
        resolve(data)
      })
      .catch(error => {
        if (showToast) EventBus.emit('ajaxErrorToast', error.errmsg || errToastText + error)
        reject(error)
      })
  })
}

export const request = ['get', 'post'].reduce((api, method) => {
  api[method] = setRequest.bind(null, method)
  return api
}, {})

/**
 * 通用中间件处理方法, 支持多种中间件定义方式
 * @param {Iterator} middlewares 迭代器
 */
export const createHelper =
  (middlewares = []) =>
  (method, ...params) => {
    const ret = method.apply(null, params)
    return new Promise((resolve, reject) => {
      const iterator = middlewares[Symbol.iterator]()
      const next = result => {
        const el = iterator.next()

        if (el.done) {
          result.then(resolve, reject)
          return
        }
        result = el.value(result)
        next(result)
      }
      next(ret)
    })
  }

export function SodaGlobalParams() {
  return new Promise((resolve, reject) => {
    if (window && window.Soda && window.Soda.getGlobalParams) {
      try {
        Soda.getGlobalParams((result = {}) => {
          const { errNo = 0, data = {} } = result
          for (const key in data) {
            if (!data[key]) {
              delete data[key]
            }
          }
          if (errNo === 0) {
            resolve(data)
          } else {
            resolve({})
          }
        })
      } catch (e) {
        resolve({})
      }
    } else {
      resolve({})
    }
  })
}

export const requestHelper = createHelper([errnoData, preloading])
export const requestSilence = createHelper([errnoData])
